import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

export const useGetLoginMode = () => {
    const usernameEmailSwitcher = useAppSelector(prop('usernameEmailSwitcher'));

    return useCallback((userName) => usernameEmailSwitcher && userName.includes('@') ? 'email' : 'userName'
        , [usernameEmailSwitcher]);
};
